import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { SiteDataProvider } from "@/context/SiteData";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import SempliceMente from "@/pages/SempliceMente";
import SempliceMenteDetail from "@/pages/SempliceMenteDetail";
import Docenti from "@/pages/Docenti";
import DocenteDetail from "@/pages/DocenteDetail";
import Eventi from "@/pages/Eventi";
import Gallery from "@/pages/Gallery";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

const EMAIL = "formazione@rischio-zero.it";

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return null;
}

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center"><Loader2 className="animate-spin text-[#EA6A0A]" size={30} /></div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

function PublicLayout() {
  const bookGeneric = () => { window.location.href = `mailto:${EMAIL}?subject=${encodeURIComponent("Richiesta prenotazione corso")}`; };
  return (
    <>
      <Header onBook={bookGeneric} />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/semplicemente" element={<SempliceMente />} />
        <Route path="/semplicemente/:slug" element={<SempliceMenteDetail />} />
        <Route path="/docenti" element={<Docenti />} />
        <Route path="/docenti/:id" element={<DocenteDetail />} />
        <Route path="/eventi" element={<Eventi />} />
        <Route path="/gallery" element={<Gallery />} />
      </Routes>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-white">
      <AuthProvider>
        <SiteDataProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
            <Route path="/*" element={<PublicLayout />} />
          </Routes>
        </BrowserRouter>
        </SiteDataProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
